import { ITicket } from 'app/services/api5-service/api.interface';
import { map } from 'rxjs/operators';

import { prefix } from 'common/form-id-prefix/form-id-prefix.utils';

import { FormScrollerProps } from './model/form-scroller-props.interface';

import { ISPFieldConfig, ISPFieldType, ISPFormState } from '../../model';

/**
 * Get props for chat field
 *
 * @param control
 * @param state
 */
export function getFormScrollerProps(
  control: ITicket,
  state: ISPFormState,
): FormScrollerProps {
  return {
    layoutPlace: 'absolute',
    bottomScrollToSelector: prefix(
      state.layoutService,
      'isp-chat > isp-chat-bubble:last-child',
    ),
    displayButtons$: state.docSubject.pipe(
      map(doc =>
        Boolean(
          doc.mlist?.find(mlist => mlist.$name === control.$name)?.message
            ?.length,
        ),
      ),
    ),
  };
}
/**
 * Get config for chat field
 *
 * @param control
 * @param state
 */
export function getFormScrollerConfig(
  control: ITicket,
  state: ISPFormState,
): ISPFieldConfig<ISPFieldType.FormScroller> {
  const props = getFormScrollerProps(control, state);

  return {
    type: ISPFieldType.FormScroller,
    props,
  };
}
